module.exports = __webpack_public_path__ + "static/media/The-West-Subscription-Black-Friday.51cfd54c.png";